import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { PortalUserRegistration } from '../types';
import env from '@/env';

export const getPortalUserRegistrationById = async ({
  registrationUrlId,
}: {
  registrationUrlId: string;
}): Promise<PortalUserRegistration> => {
  const fetchResponse = await fetch(
    `${
      env.VITE_API_URL
    }/pb/s/api/sqo-portal/auth/portal-user-registrations/${registrationUrlId}?${new URLSearchParams(
      {
        companyId: env.VITE_IDSYSDBCOMPANY,
      }
    )}`,
    { method: 'GET' }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as PortalUserRegistration;
  return response;
};
